import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteDataByUrl } from '@/routes/Routes.helpers';

interface PageMetaOverrideIF {
    title?: string;
    description?: string;
}

const updateMeta = (
    attribute: 'name' | 'property',
    name: string,
    content: string,
): void => {
    let tag = document.querySelector(`meta[${attribute}='${name}']`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, name);
        document.head.append(tag);
    }
    tag.setAttribute('content', content);
};

export const usePageMeta = (override?: PageMetaOverrideIF): void => {
    const location = useLocation();

    useEffect(() => {
        const route = getRouteDataByUrl(location.pathname);

        const appName = import.meta.env.VITE_APP_NAME;
        const defaultDesc = import.meta.env.VITE_APP_DESCRIPTION;

        const title =
            override?.title ??
            (route?.title ? `${route.title} — ${appName}` : appName);
        const desc = override?.description ?? route?.description ?? defaultDesc;

        document.title = title;

        updateMeta('name', 'description', desc);
    }, [location.pathname]);
};
